exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-state-0-bg[data-v-08d5f345]{background-color:#f94144}.order-state-10-bg[data-v-08d5f345]{background-color:#f3722c}.order-state-20-bg[data-v-08d5f345]{background-color:#f8961e}.order-state-23-bg[data-v-08d5f345]{background-color:#f9c74f}.order-state-24-bg[data-v-08d5f345]{background-color:#ff986c}.order-state-26-bg[data-v-08d5f345]{background-color:#90be6d}.order-state-30-bg[data-v-08d5f345]{background-color:#577590}.order-state-40-bg[data-v-08d5f345]{background-color:#43aa8b}.ad-wrapper[data-v-08d5f345]{padding:.3rem .6rem}.ad-wrapper img[data-v-08d5f345]{border-radius:.5rem;width:100%;margin-bottom:.5rem}", ""]);

// exports
